import { RevisionDetail } from 'views/RevisionHistory/RevisionDtos';

export const filterByRegExRevisionHistoryByAttributeName = (regexp: RegExp[], revisionList: RevisionDetail[]) => {
  return revisionList.filter((text) => {
    return !regexp.some((regex) => {
      return regex.test(text.fieldNameTranslation ?? text.fieldName ?? '');
    });
  });
};

export const filterRevisionHistoryByAttributeName = (attributeList: string[], revisionList: RevisionDetail[]) => {
  return revisionList.filter((text) => {
    return !attributeList.some((attr) => {
      return attr === text.section + '#' + (text.fieldName || text.fieldNameTranslation || '');
    });
  });
};

const sortData = (data?: RevisionDetail[]) => {
  const sortedData = data ?? [];

  sortedData.sort((change1, change2) => {
    if (change1.section === change2.section) {
      return change1.fieldNameTranslation < change2.fieldNameTranslation ? -1 : 1;
    }
    return change1.section < change2.section ? -1 : 1;
  });
  return sortedData;
};

export const filterByRegexAndSortRevisionHistoryEntries = (regexp: RegExp[], data?: RevisionDetail[]) => {
  return filterByRegExRevisionHistoryByAttributeName(regexp, sortData(data));
};

export const filterAndSortRevisionHistoryEntries = (attributeList: string[], data?: RevisionDetail[]) => {
  return filterRevisionHistoryByAttributeName(attributeList, sortData(data));
};
